export const errorsCatalog = {
    PYCAD_100: {
        scope: "PYCAD",
        code: 100,
        title: "Impossible to read the step file",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYCAD_101: {
        scope: "PYCAD",
        code: 101,
        title: "Invalid cad file",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYCAD_102: {
        scope: "PYCAD",
        code: 102,
        title: "Invalid child. Skipped.",
        example: null,
        severity: "warning",
        action: "contact_support",
        status: 422,
    },
    PYCAD_103: {
        scope: "PYCAD",
        code: 103,
        title: "Dimensions error.",
        example: null,
        severity: "warning",
        action: "contact_support",
        status: 422,
    },
    PYCAD_104: {
        scope: "PYCAD",
        code: 104,
        title: "Analysis error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYCAD_105: {
        scope: "PYCAD",
        code: 105,
        title: "Features detection error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYCAD_106: {
        scope: "PYCAD",
        code: 106,
        title: "Part type error",
        example: null,
        severity: "warning",
        action: "contact_support",
        status: 422,
    },
    PYCAD_107: {
        scope: "PYCAD",
        code: 107,
        title: "Face geometry error",
        example: null,
        severity: "warning",
        action: "contact_support",
        status: 422,
    },
    PYCAD_200: {
        scope: "PYCAD",
        code: 200,
        title: "Build shape Error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYCAD_201: {
        scope: "PYCAD",
        code: 201,
        title: "Upload error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_100: {
        scope: "PYPLAN",
        code: 100,
        title: "Config error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_101: {
        scope: "PYPLAN",
        code: 101,
        title: "LLM extraction pipeline failed",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_102: {
        scope: "PYPLAN",
        code: 102,
        title: "Worker error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_103: {
        scope: "PYPLAN",
        code: 103,
        title: "Job error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_104: {
        scope: "PYPLAN",
        code: 104,
        title: "File handling error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_105: {
        scope: "PYPLAN",
        code: 105,
        title: "Image embedding error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_106: {
        scope: "PYPLAN",
        code: 106,
        title: "Image processing error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_107: {
        scope: "PYPLAN",
        code: 107,
        title: "Test error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_108: {
        scope: "PYPLAN",
        code: 108,
        title: "Downloading weights error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_109: {
        scope: "PYPLAN",
        code: 109,
        title: "Flat pattern error",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_110: {
        scope: "PYPLAN",
        code: 110,
        title: "DXF to text conversion truncated because the text is to long",
        example: null,
        severity: "warning",
        action: "contact_support",
        status: 422,
    },
    PYPLAN_111: {
        scope: "PYPLAN",
        code: 111,
        title: "DXF without measurements detected",
        example: null,
        severity: "warning",
        action: "contact_support",
        status: 422,
    },
    PREDICTION_100: {
        scope: "PREDICTION",
        code: 100,
        title: "An error occured during the prediction",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PREDICTION_101: {
        scope: "PREDICTION",
        code: 101,
        title: "Static alert : Alert on cycle time prediction failed",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PREDICTION_102: {
        scope: "PREDICTION",
        code: 102,
        title: "Static alert : Process should not be used in prediction",
        example: "FOLDING for flat sheet",
        severity: "warning",
        action: "fix_input",
        status: 422,
    },
    PREDICTION_103: {
        scope: "PREDICTION",
        code: 103,
        title: "Static alert : Input missing",
        example: null,
        severity: "warning",
        action: "fix_input",
        status: 422,
    },
    PREDICTION_104: {
        scope: "PREDICTION",
        code: 104,
        title: "Static alert : Wrong input type",
        example: null,
        severity: "warning",
        action: "fix_input",
        status: 400,
    },
    PREDICTION_105: {
        scope: "PREDICTION",
        code: 105,
        title: "Static alert : Not configured for this process",
        example: null,
        severity: "info",
        action: "contact_support",
        status: 422,
    },
    PREDICTION_106: {
        scope: "PREDICTION",
        code: 106,
        title: "Static alert : unknown part_type",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 400,
    },
    PREDICTION_107: {
        scope: "PREDICTION",
        code: 107,
        title: "Static alert : Material not supported to build the alert",
        example: null,
        severity: "warning",
        action: "fix_input",
        status: 400,
    },
    PREDICTION_108: {
        scope: "PREDICTION",
        code: 108,
        title: "Process Presence",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 400,
    },
    PREDICTION_109: {
        scope: "PREDICTION",
        code: 109,
        title: "Cycle time is out of bounds",
        example: null,
        severity: "warning",
        action: "check",
        status: 400,
    },
    PYSTRUCT_100: {
        scope: "PYSTRUCT",
        code: 100,
        title: "LLM call failed",
        example: null,
        severity: "error",
        action: "check",
        status: 422,
    },
    PYSTRUCT_110: {
        scope: "PYSTRUCT",
        code: 110,
        title: "Impossible to download the input file",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYSTRUCT_111: {
        scope: "PYSTRUCT",
        code: 111,
        title: "Impossible to parse the input file",
        example: null,
        severity: "error",
        action: "fix_input",
        status: 422,
    },
    PYSTRUCT_112: {
        scope: "PYSTRUCT",
        code: 112,
        title: "No reference column identified",
        example: null,
        severity: "warning",
        action: "fix_input",
        status: 422,
    },
    PYSTRUCT_113: {
        scope: "PYSTRUCT",
        code: 113,
        title: "No part reference extracted from the email",
        example: null,
        severity: "warning",
        action: "fix_input",
        status: 422,
    },
    PYSTRUCT_120: {
        scope: "PYSTRUCT",
        code: 120,
        title: "High task failure rate",
        example: null,
        severity: "error",
        action: "check",
        status: 422,
    },
    PYSTRUCT_121: {
        scope: "PYSTRUCT",
        code: 121,
        title: "No part completed",
        example: null,
        severity: "warning",
        action: "check",
        status: 422,
    },
    PYSTRUCT_130: {
        scope: "PYSTRUCT",
        code: 130,
        title: "Mandatory material base fields not mapped",
        example: null,
        severity: "warning",
        action: "fix_input",
        status: 422,
    },
    PYSTRUCT_131: {
        scope: "PYSTRUCT",
        code: 131,
        title: "Material base file has too many rows",
        example: null,
        severity: "warning",
        action: "fix_input",
        status: 422,
    },
    PYSTRUCT_140: {
        scope: "PYSTRUCT",
        code: 140,
        title: "Job timed out",
        example: null,
        severity: "error",
        action: "retry",
        status: 422,
    },
    PYSTRUCT_141: {
        scope: "PYSTRUCT",
        code: 141,
        title: "Job failed unexpectedly",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYSHARED_100: {
        scope: "PYSHARED",
        code: 100,
        title: "File encoding failed",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYSHARED_101: {
        scope: "PYSHARED",
        code: 101,
        title: "Unsupported file extension for the encoding",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYSHARED_102: {
        scope: "PYSHARED",
        code: 102,
        title: "Part is invalid",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    PYSHARED_103: {
        scope: "PYSHARED",
        code: 103,
        title: "Part metadata is invalid",
        example: null,
        severity: "warning",
        action: "contact_support",
        status: 422,
    },
    PYSHARED_104: {
        scope: "PYSHARED",
        code: 104,
        title: "Part measures is invalid",
        example: null,
        severity: "warning",
        action: "contact_support",
        status: 422,
    },
    PYSHARED_105: {
        scope: "PYSHARED",
        code: 105,
        title: "Part features is invalid",
        example: null,
        severity: "warning",
        action: "contact_support",
        status: 422,
    },
    NESTING_100: {
        scope: "NESTING",
        code: 100,
        title: "Flat pattern approximated by the bounding box of a 2D drawing",
        example: null,
        severity: "warning",
        action: "check",
        status: 422,
    },
    NESTING_101: {
        scope: "NESTING",
        code: 101,
        title: "Part does not fit on the sheet",
        example: null,
        severity: "error",
        action: "fix_input",
        status: 422,
    },
    NESTING_102: {
        scope: "NESTING",
        code: 102,
        title: "Part flat pattern has an invalid shape",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    NESTING_103: {
        scope: "NESTING",
        code: 103,
        title: "Part flat pattern has a null area",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    NESTING_104: {
        scope: "NESTING",
        code: 104,
        title: "No nesting solution could be found",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    NESTING_105: {
        scope: "NESTING",
        code: 105,
        title: "Nesting solution is invalid",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
    NESTING_106: {
        scope: "NESTING",
        code: 106,
        title: "Nesting instance is invalid",
        example: null,
        severity: "error",
        action: "contact_support",
        status: 422,
    },
};
